// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ViewColumns(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ViewColumns" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M14 4L10 4L10 20H14L14 4ZM20 4L16 4L16 20H20L20 4ZM8 20L8 4L4 4L4 20H8Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ViewColumns.js.map